import Validator from '@/shared/utils/validator'

async function triggerAction(dataKey, data, networkRepo) {
  Validator.require('dataKey', dataKey, 'string')

  const response = await networkRepo.triggerAction(dataKey, data)

  Validator.requireObject('processorResponse', response)
  Validator.require('response.statusCode', response.statusCode, 'number')
  return response
}

export default triggerAction
